export default "__VITE_ASSET__B5XKM3ja__"